import Dropdown from './dropdown';
import DropdownItem from './dropdown-item';
import DropdownMenu from './dropdown-menu';

/* istanbul ignore next */
Dropdown.install = function(Vue) {
  Vue.component(Dropdown.name, Dropdown);
  Vue.component(DropdownItem.name, DropdownItem);
  Vue.component(DropdownMenu.name, DropdownMenu);
};

export default Dropdown;
